import { GET_NEWS_FOR_MANAGER } from '@/domain/navigation/features/navigation/hooks/useNews/graphql/queries';
import { News } from '../../entities/news';
import {
  GetNewsForManagerQuery,
  GetNewsForManagerQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

export function useNews(): {
  news: News[];
  error?: string;
} {
  const result = useSuspenseQuery<
    GetNewsForManagerQuery,
    GetNewsForManagerQueryVariables
  >(GET_NEWS_FOR_MANAGER);

  if (result.error) {
    Sentry.captureException(result.error.cause.message);
    return { news: [] };
  }

  const news: News[] = [];
  if (result.data.navigation_manager.__typename === 'navigation_manager') {
    const managerResult = result.data.navigation_manager;
    managerResult.news.forEach((newsItem) => {
      const mappedNews = new News({
        id: newsItem.id,
        titel: newsItem.titel,
        inhalt: newsItem.inhalt,
        veroeffentlichtAm: newsItem.veroeffentlichtAm,
        istGelesen: newsItem.istGelesen,
        bildUrl: newsItem.bildUrl,
      });
      news.push(mappedNews);
    });
  }

  return { news };
}
